export default __webpack_public_path__ + "static/media/portfolio-hover-177.d1dbca34.jpg";